import { render } from "./orders-trades-block.vue?vue&type=template&id=a4561462&scoped=true"
import script from "./orders-trades-block.vue?vue&type=script&lang=js"
export * from "./orders-trades-block.vue?vue&type=script&lang=js"

import "./orders-trades-block.vue?vue&type=style&index=0&id=a4561462&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4561462"]])

export default __exports__